'use strict';
module.exports = require('./ContextMenu.vue');